import { Auth } from "../services/authService";
const { BACKEND_URL } = require("../config/config");

const authController = new Auth();

export async function createUploadFile(
    file, 
    exp, 
    req, 
    id_estado, 
    tipo_documento, 
    id_usuario,
    id_mov
  ) {
  const token = authController.getAccessToken();
  console.log("file", file);
  try {
    if (token) {
      let payload = {
        fileName: file.path,
        contentType: file.type || "",
        fileSize: file.size || "",
        fileExtension: file.fileExtension || "",
        idExpediente: exp || null,
        idRequisito: req || null,
        id_estado: id_estado || null,
        tipo_documento: tipo_documento || null,
        id_usuario: id_usuario || null,
        id_mov: id_mov || null 
      };

      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      };
      const url = `${BACKEND_URL}/uploadFile`;
      const responsePromise = await fetch(url, params);
      const response = await responsePromise.json();

      const { signedUrl, fileId, fileName, contentDisposition } = response.data;

      await fetch(signedUrl, {
        method: "PUT",
        body: file,
        headers: {
          "Content-Type": `${file.type}`,
          // Tiene que coincidir exactamente con el Content-Disposition que
          // el backend usó al firmar la URL, o S3 rechaza el PUT por firma
          // inválida (ver aws.js/uploadFileAWS).
          ...(contentDisposition ? { "Content-Disposition": contentDisposition } : {}),
        },
      });

      return { status: 200, url: signedUrl, fileId, fileName };
    }else{

    }
  } catch (err) {
    console.log("Error subiendo archivo", err);
    return false;
  }
}

export async function creatSignUpFiles(
  file
) {
  const token = authController.getAccessToken();
  console.log("file", file);
  try {
    let payload = {
      fileName: file.path,
      contentType: file.type || "",
      fileSize: file.size || "",
      fileExtension: file.fileExtension || "",
    };

    const params = {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload),
    };

    const url = `${BACKEND_URL}/uploadRegisterFile`;
    const responsePromise = await fetch(url, params);
    const response = await responsePromise.json();

    const { signedUrl, fileId, fileName } = response.data;

    await fetch(signedUrl, {
      method: "PUT",
      body: file,
      headers: {
        "Content-Type": `${file.type}`,
      },
    });

    return { status: 200, url: signedUrl, fileId, fileName };

  } catch (err) {
    console.log("Error subiendo archivo", err);
    return false;
  }
}

export async function creatFile(
  file
) {
  const token = authController.getAccessToken();
  console.log("file", file);
  try {
    let payload = {
      fileName: file.path,
      contentType: file.type || "",
      fileSize: file.size || "",
      fileExtension: file.fileExtension || "",
    };

    const params = {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload),
    };

    const url = `${BACKEND_URL}/uploadFile`;
    const responsePromise = await fetch(url, params);
    const response = await responsePromise.json();

    const { signedUrl, fileId, fileName } = response.data;

    await fetch(signedUrl, {
      method: "PUT",
      body: file,
      headers: {
        "Content-Type": `${file.type}`,
      },
    });

    return { status: 200, url: signedUrl, fileId, fileName };

  } catch (err) {
    console.log("Error subiendo archivo", err);
    return false;
  }
}



export async function obtenerDocumento(key) {
  const token = authController.getAccessToken();
  try {
    console.log("AWS Key", key);

    const url = `${BACKEND_URL}/obtenerDocumento`;

    const payload = { key: key};

    const params = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `${token}`,
      },
      body: JSON.stringify(payload),
    };

    const responsePromise = await fetch(url, params);
    const response = await responsePromise.json();

    return { status: 200, url: response.signedUrl };  
  } catch (err) {
    console.log("Error obteniendo documento", err);
    return null;
  }
}

export async function deleteFile(id_mov) {
  const token = authController.getAccessToken();
  try {
    console.log("Eliminando archivo con id_mov", id_mov);

    const url = `${BACKEND_URL}/deleteFile/${id_mov}`;

    const params = {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `${token}`,
      },
    };

    const responsePromise = await fetch(url, params);
    const response = await responsePromise.json();

    return { status: 200, url: response.signedUrl };  
  } catch (err) {
    console.log("Error eliminando documento", err);
    return null;
  }
}


